import type { ReactNode } from 'react';
import ArrowRightIcon from './icons/ArrowRightIcon';

// Label + arrow that slides in on hover. Drop inside any element carrying the
// `group` class (a Button with `arrow`, or the hero CTA anchor). Idle keeps the
// label centred with the arrow collapsed; hover expands the arrow in and lets the
// label nudge left. Uses max-width (not width) so the idle state never jumps.
export default function ArrowLabel({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex items-center">
      {children}
      <span className="inline-flex max-w-0 overflow-hidden opacity-0 transition-all duration-200 ease-out motion-reduce:transition-none group-hover:ml-2 group-hover:max-w-[1.5rem] group-hover:opacity-100">
        <ArrowRightIcon className="h-5 w-5 shrink-0" />
      </span>
    </span>
  );
}
